import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 製造命令狀態（Draft：`mom.work_order.material_analysis.manufacturing_command_status`）。
 * GET `/mom/work-order/material-analysis/manufacturing-command-status` → detail。
 *
 * `data`：**僅** `summary`、`workOrders[]`、`dataQuality`
 * （不回跨工單物料彙總／在途 PO 清單）。
 *
 * `workOrders[]`：`workOrderNo`、`scheduledStartDate`、`mtr`、`processingFactory`、
 * `workWarehouse`、`workOrderStatus`、`materialStatus`、數量欄、`warnings`、`materialChecks[]`。
 *
 * `materialChecks[]`：`requiredQty`／`issuedQty`／`remainingRequiredQty`、
 * `onHandAllocatedQty`／`inTransitAllocatedQty`／`lateInTransitQty`／`shortageQty`／
 * `earliestCoverDate`、`materialStatus`、`allocations[]`。
 *
 * @param {object} [listQuery]
 */
export async function fetchWorkOrderManufacturingCommandStatus(listQuery) {
  const { data: raw } = await request.get(
    '/mom/work-order/material-analysis/manufacturing-command-status',
    {
      params: listQuery ? listQueryToApiParams(listQuery) : undefined,
    },
  );
  return parseVer4DetailResponse(raw);
}
